module.exports = __webpack_public_path__ + "static/media/CyberLogovo_2_t.6d26e3bc.jpg";